import React, { useCallback, useState } from "react";
import { SwmcFooter } from "footer-component";

import "./index.css";

const CustomFooter = () => {
  return (
    <div>
      <SwmcFooter type="swmc" showTacanewLogo={false} nydisclaimer={false} />
    </div>
  );
};

export default CustomFooter;